import { handleError } from '../../../redux/actions/common-message/message-action';
import {
  getContentSchemaFromContentFul,
  makeApiCall
} from '../../../redux/actions/common/common-action';
import { API_URL } from '../../../utils/config';
import { KeyValuePairs } from './interface';

export const updateTempTransactionWithId = (tempTransactionId: string, data: KeyValuePairs) => {
  return async (dispatch: (data: any) => void): Promise<boolean> => {
    try {
      const response = await makeApiCall({
        method: 'patch',
        url: `${API_URL}/niumForex/temp-transaction/${tempTransactionId}`,
        withCredentials: true,
        data
      });
      if (response?.data?.success) {
        return true;
      }
      return false;
    } catch (error) {
      dispatch(handleError(error));
      return false;
    }
  };
};

export const getA2Form = (transactionId: number) => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/niumForex/a2Form/generate/${transactionId}`,
        withCredentials: true
      });
      if (response?.data?.success) {
        return response.data.data;
      }
      return false;
    } catch (error) {
      dispatch(handleError(error));
      return false;
    }
  };
};

export const getESignInRedirectionUrl = (transactionId: number) => {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/niumForex/e-sign/initiate`,
        data: { transactionId },
        withCredentials: true
      });
      if (response?.data?.success) {
        return response.data.data;
      }
      return false;
    } catch (error) {
      dispatch(handleError(error));
      return false;
    }
  };
};

export function getESignInStatus(transactionId: number) {
  return async (dispatch: (data: any) => void): Promise<any> => {
    try {
      const response = await makeApiCall({
        method: 'get',
        url: `${API_URL}/niumForex/e-sign/status`,
        params: { transactionId },
        withCredentials: true
      });
      if (response?.data?.success) {
        return response.data.data?.isA2FormEsigned;
      }
      return false;
    } catch (exception) {
      dispatch(handleError(exception));
      return false;
    }
  };
}

export const maskPAN = (panNumber: string): string => {
  return panNumber ? '*'.repeat(6) + panNumber.slice(6) : '';
};

export const maskAadhar = (aadharNumber: string): string => {
  return aadharNumber ? '*'.repeat(8) + aadharNumber.slice(8) : '';
};

export const getCMSDataForA2FormMessage = async () => {
  const response = await getContentSchemaFromContentFul('pageJsonDataView', 'NIUM_FOREX_REFERRAL');
  return response?.labels?.value;
};
